import { __assign } from '../_virtual/_tslib.js';
import React, { useState, useEffect } from 'react';

function clientOnly(InnerComponent) {
  var WrapperComponent = function WrapperComponent(props) {
    var _a = useState(false),
        isMounted = _a[0],
        setIsMounted = _a[1];

    useEffect(function () {
      return setIsMounted(true);
    }, []);

    if (isMounted) {
      return React.createElement(InnerComponent, __assign({}, props));
    } else {
      return null;
    }
  };

  return WrapperComponent;
}

export default clientOnly;
//# sourceMappingURL=clientOnly.js.map
